/*
* 智慧服务
* */
export default [
    // 发布公告
    {
        path : '/announcement',
        name : 'announcement',
        component : resolve => {
            require(['components/SmartService/announcement.vue'], resolve);
        },
        meta : {
            login : true,
            title : '发布公告'
        }
	},
	// 发布社区动态
    {
        path : '/communityDynamic',
        name : 'communityDynamic',
        component : resolve => {
            require(['components/SmartService/communityDynamic.vue'], resolve);
        },
        meta : {
            login : true,
            title : '发布社区动态'
        }
    },
    // 广告管理
    {
        path : '/advertisingManagement',
        name : 'advertisingManagement',
        component : resolve => {
            require(['components/SmartService/advertisingManagement.vue'], resolve);
        },
        meta : {
            login : true,
            title : '广告管理'
        }
	},
 // app启动页管理
		{
			path : '/openningManagement',
			name : 'openningManagement',
			component : resolve => {
				require(['components/SmartService/openningManagement.vue'], resolve);
			},
			meta : {
				login : true,
				title : 'APP启动页管理'
			}
		},
	// 资讯管理
	{
	    path : '/newsManagement',
	    name : 'newsManagement',
	    component : resolve => {
	        require(['components/SmartService/newsManagement.vue'], resolve);
	    },
	    meta : {
	        login : true,
	        title : '资讯管理'
	    }
	},
	// 法律法规
	{
	    path : '/lawsRegulations',
	    name : 'lawsRegulations',
	    component : resolve => {
	        require(['components/SmartService/lawsRegulations.vue'], resolve);
	    },
	    meta : {
	        login : true,
	        title : '法律法规'
	    }
	},
	// 栏目管理
	{
	    path : '/columnManage',
	    name : 'columnManage',
	    component : resolve => {
	        require(['components/columnManage/index.vue'], resolve);
	    },
	    meta : {
	        login : true,
	        title : '栏目管理'
	    }
	},
	// 意见管理
	{
	    path : '/suggestionBox',
	    name : 'suggestionBox',
	    component : resolve => {
	        require(['components/suggestionBox/index.vue'], resolve);
	    },
	    meta : {
	        // login : true,
	        title : '意见管理'
	    }
	},
	//栏目管理
	{
		path:'/columnBranch',
		name:'columnBranch',
		component:resolve=>{
			require(['components/SmartService/columnBranch'],resolve)
		},
		meta:{
			title:'栏目管理'
		}

	}
]



// WEBPACK FOOTER //
// ./src/router/routers/smartservice.js